export function init() {
  var isDown = false
  var startX
  var scrollLeft

  function updatePosition() {
    document.querySelectorAll('[data-bespoke] .container .flex').forEach(function (content) {
      if (content.scrollWidth <= window.innerWidth) {
        content.classList.add('justify-content-center')
      } else {
        content.classList.remove('justify-content-center')
      }
    })
  }

  window.addEventListener('resize', updatePosition)

  document.querySelectorAll('[data-drag-horizontal]').forEach(function (slider) {
    setTimeout(function () {
      if (slider.hasAttribute('data-bespoke')) {
        updatePosition()
      }
    }, 5)

    slider.addEventListener('mousedown', (e) => {
      isDown = true
      slider.classList.add('active')
      startX = e.pageX - slider.offsetLeft
      scrollLeft = slider.scrollLeft
    })

    slider.addEventListener('mouseleave', () => {
      isDown = false
      slider.classList.remove('active')
    })

    slider.addEventListener('mouseup', () => {
      isDown = false
      slider.classList.remove('active')
    })

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return
      e.preventDefault()
      const x = e.pageX - slider.offsetLeft
      const walk = x - startX
      slider.scrollLeft = scrollLeft - walk
    })
  })
}
